import * as React from "react";
import {CSSProperties} from "react";
import useWindowDimensions from "../utils/dimensionsHook";

export const SelkiesDisplay: React.FC<{address?: string}> = ({address}) => {
    const {width, height} = useWindowDimensions();

    const containerStyle: CSSProperties = {
        top: 0,
        left: 0,
        width,
        backgroundColor: "#363D49",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflowY: "auto",
        height: height,
        position: "fixed",
    };

    return (
        <div style={containerStyle} className="guacDisplay">
            <iframe src={address} width={width} height={height} allow="clipboard-read *; clipboard-write *"/>
        </div>
    );
};
